import React, { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import "bootstrap/dist/css/bootstrap.min.css";

// Inicializar Firebase
const functions = getFunctions();

function SimpleInspector() {
  const getOpenAIResponse = httpsCallable(functions, "getOpenAIResponse");

  const [inputText, setInputText] = useState(""); // Entrada de texto opcional
  const [selectedImage, setSelectedImage] = useState(null); // Imagen seleccionada
  const [isLoading, setIsLoading] = useState(false);
  const [resultado, setResultado] = useState("");
  const [error, setError] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setSelectedImage(file); // Guardar la imagen seleccionada
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };

  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file); // Esto convierte la imagen a Base64
    });
  };

  const realizarConsulta = async () => {
    if (!selectedImage) {
      alert("Debes seleccionar una imagen del anaquel.");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      // Convertir la imagen seleccionada a Base64
      const base64Image = await convertImageToBase64(selectedImage);

      // Construir la conversación
      const conversation = [
        {
          role: "system",
          content:
            "JSON. Eres un asistente de una empresa de merchandising. Tu tarea es analizar imágenes de anaqueles para ofrecer información detallada sobre los productos. Además de eso, necesito que muestres el nombre del producto, la marca, el precio asociado al mismo y las unidades visibles del producto. De no visualizarse alguna de estas características, debes poner un (No visible) o un (No encontrado).",
        },
        {
          role: "user",
          content:
          "JSON. Por favor, estudia la imagen del anaquel y proporciona una descripción detallada de todos y cada uno de los productos visibles, incluye nombre, marca, precio, unidades (cantidad de productos visibles en la imagen pero solo de la primera cara, sin tener en cuenta los productos que están detrás del anaquel, solo la primera cara visible) y el color del producto. Otro de los puntos importantes que quiero es el porcentaje de participación de cada marca. puesto que, pueden haber varios productos iguales pero de marcas diferentes así que quiero que por cada marca me digas el porcentaje de participación que tiene en el anaquel contra las demás marcas, ejemplo: si hay dos productos iguales que ocupan cada uno la mitad del anaquel y son de marcas diferentes necesitos que digas algo como marca  porcentaje de participación: 50%  y así con cada marca. Esto es importante, el porcentaje de participaación debes definirlo para cada marca, si hay productos iguales de marcas diferentes, ahí comparas la competencia. Si no puedes especificar alguno de los valores mencionados porque no se encuentran, coloca (No visible) o (No encontrado). Necesito que menciones cada producto una sola vez, analiza la imagen como un todo, como un bloque, para que así no dupliques información; de igual manera, haz una verificación a la respuesta que me diste y quita la información de productos duplicados. Si aparece una persona en la imagen, omítela por completo. Otro aspecto ue necesito es la participación en el anaquel de cada producto, necesito saber en porcentaje, cuanto espacio ocupa en el anaquel ese producto",
        },
        {
          role: "user",
          content: [
            { type: "image_url", image_url: { url: base64Image, detail: "high" } },
          ],
        },
      ];

      // Llamar a la función de Firebase
      const response = await getOpenAIResponse({ conversation });

      setResultado(JSON.stringify(response.data, null, 2));
    } catch (err) {
      setError(
        `Error al realizar la consulta: ${err.message} - Detalles: ${JSON.stringify(err)}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex flex-column bg-light py-5">
      {/* Columna izquierda */}
      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card shadow">
            <div className="card-body">
              <h2 className="card-title text-center text-primary mb-4">
                Analiza un Anaquel
              </h2>

              <div className="mb-3">
                <label htmlFor="image-input" className="form-label">
                  Cargar imagen del Anaquel
                </label>
                <input
                  id="image-input"
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="form-control"
                />
              </div>

              {selectedImage && (
                <div className="mb-3 text-center">
                  <img
                    src={URL.createObjectURL(selectedImage)}
                    alt="Preview"
                    className="img-thumbnail w-50"
                  />
                  <div className="mt-3 d-flex justify-content-center gap-3">
                    <button
                      className="btn btn-danger"
                      onClick={handleRemoveImage}
                    >
                      Quitar imagen
                    </button>
                    <label
                      className="btn btn-primary"
                      htmlFor="image-input"
                    >
                      Cambiar imagen
                    </label>
                  </div>
                </div>
              )}

              <button
                className={`btn btn-success w-100 ${isLoading ? "disabled" : ""}`}
                onClick={realizarConsulta}
                disabled={isLoading}
              >
                {isLoading ? "Cargando..." : "Enviar"}
              </button>
            </div>
          </div>
        </div>

        {/* Columna derecha */}
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body">
              <h2 className="card-title text-center text-primary mb-4">
                Resultado del análisis
              </h2>
              {error && <p className="text-danger">{error}</p>}
              {resultado ? (
                <pre className="bg-light p-3 border rounded overflow-auto w-100 h-100">
                  {resultado}
                </pre>
              ) : (
                <p className="text-muted">El resultado aparecerá aquí después del análisis.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SimpleInspector;
